"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobile = void 0;
function isAndroid() {
    return typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent);
}
function isSmallIOS() {
    return typeof navigator !== 'undefined' && /iPhone|iPod/.test(navigator.userAgent);
}
function isLargeIOS() {
    return (typeof navigator !== 'undefined' &&
        (/iPad/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)));
}
function isIOS() {
    return isSmallIOS() || isLargeIOS();
}
function isMobile() {
    return isAndroid() || isIOS();
}
exports.isMobile = isMobile;
//# sourceMappingURL=utils.js.map